var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepressiya(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 154,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#depressiya_svg__clip0_632_7271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.766 26.792s-4.748-8.328-14.067-14.213c-10.404-6.564-15.038.83-11.907 6.323 7.93 13.932 25.974 7.89 25.974 7.89zM121.626 47.67s5.663 7.683 7.454 18.89c1.997 12.515-6.306 14.268-10.039 9.202-9.473-12.845 2.585-28.088 2.585-28.088v-.004z",
    fill: "#333",
    stroke: "#333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.058 26.665l1.794-2.525c.953-1.341 2.77-1.626 4.058-.63 1.285.995 1.558 2.89.606 4.231l-1.795 2.526c-.952 1.341-2.769 1.625-4.057.63-1.285-.995-1.558-2.886-.602-4.232h-.004zM121.249 50.453l2.931-.73c1.558-.389 3.12.614 3.493 2.24.373 1.626-.591 3.256-2.149 3.644l-2.931.73c-1.559.388-3.12-.615-3.493-2.24-.373-1.626.591-3.256 2.149-3.644z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.48 191.005c25.398 16.457 47.915-8.775 48.181-9.075 0 0-.65 3.894-.675 7.91-.019 2.637.236 5.319 1.118 6.98 5.335 10.016 29.828 24.448 37.028 21.869 14.834-5.312-11.202-25.055-11.593-25.359.41.161 34.816 13.906 38.142 5.35 3.367-8.675-26.099-20.009-26.099-20.009v-.869l.222-45.203s6.468-8.379.672-16.288c0 0 9.37-6.75 2.898-14.194 0 0 2.898-3.256 1.562-4.655-1.337-1.395-6.469 4.655-6.469 4.655s0-.569-.018-1.568c-.104-5.985-.846-27.42-6.004-35.195-3.201-4.82-5.951-5.688-7.151-5.82-.425-.05-.654 0-.654 0 1.75-.818 3.368-1.855 4.804-2.94a22.945 22.945 0 001.51-1.24c4.622-4.129 7.546-9.978 8.074-16.355.558-6.691-3.455-16.696-11.711-18.322 0 0-11.825-3.255-21.86 5.585a50.245 50.245 0 00-2.186 2.052c-8.964 8.937-15.658 21.908-15.658 21.908s-7.927-5.604-19.073-1.395c-15.392 5.819-17.914 37.854-21.27 55.454-1.108 5.792 1.44 11.296.805 16.788-.775 6.676-9.566 12.722-9.67 18.794-.435 25.264 4.84 44.492 15.075 51.126v.016z",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.402 139.879c21.794-.761 43.585-1.518 65.379-2.272 10.119-6.595 34.745-34.072 35.133-34.783-.103-5.984-1.311-29.691-6.468-37.459-3.201-4.82-5.952-5.688-7.152-5.815l-.768.12s-15.839 14.889-28.78 9.539c-11.707-4.843-8.14-18.964-8.14-18.964s-9.378-9.793-20.524-5.584c-15.392 5.819-21.403 41.498-24.76 59.097a230.666 230.666 0 00-2.606 16.953c-.775 6.676-1.21 13.103-1.314 19.175v-.007z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.992 53.262s2.208-.388 3.855 2.318c1.647 2.706-.539 7.43-5.394 8.613-5.055 1.234-8.784-3.336-8.784-3.336",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.992 53.262s2.208-.388 3.855 2.318c1.647 2.706-.539 7.43-5.394 8.613-5.055 1.234-8.784-3.336-8.784-3.336M119.244 56.96s4.294-.615 4.286 2.636M115.316 61s5.641 1.018 7.712-3.099",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7 191.547c28.352 18.479 51.242-8.033 51.512-8.333l11.275-62.13c-30.895 22.45-64.105 19.894-76.085-.38-4.002 34.46.602 62.614 13.295 70.839l.003.004z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.781 154.126l-2.23 7.211s-27.214-8.01-32.342-27.973c-5.128-19.959 20.746-37.643 20.746-37.643",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.781 154.126l-2.23 7.211s-27.214-8.01-32.342-27.973c-5.128-19.959 20.746-37.643 20.746-37.643",
    stroke: "#333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.05 143.311l13.388-7.906c12.94 29.318 35.019 23.242 35.019 23.242-.402 3.397-1.587 9.678-5.686 16.196-4.71 7.495-10.75 11.304-13.72 12.914",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.271 110.499s-.863-36.42-11.958-37.808c-8.362-1.05-10.596 7.795-10.596 7.795s-3.131-7.98-12.383-6.865C84.738 74.901 74.03 99.795 74.03 99.795l5.91 21.351",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.271 110.499s-.863-36.42-11.958-37.808c-8.362-1.05-10.596 7.795-10.596 7.795s-3.131-7.98-12.383-6.865C84.738 74.901 74.03 99.795 74.03 99.795l5.91 21.351",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.862 110.619s-2.23 14.659.982 37.293l-.982-37.293z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.862 110.619s-2.23 14.659.982 37.293",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.407 118.298s2.573 21.142 4.903 43.116c1.728 16.288 3.382 30.797 3.91 31.923l22.086-4.423-.942-33.143-.986-34.629-28.971-2.848v.004z",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.074 146.447s.672-59.097-8.255-68.87l8.255 68.87z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.074 146.447s.672-59.097-8.255-68.87",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.374 103.75s4.685-3.255 4.013-5.584c-1.203-4.186-10.537 8.467-10.537 8.467-4.962-.377-46.42 12.914-46.42 12.914L68.438 79.048c-1.31 1.672-4.847 5.735-10.906 7.714-5.409 1.772-10.005.957-12.047.465 8.466 30.248 12.55 44.65 18.962 49.792 5.8 4.655 16.282 1.861 16.282 1.861s-.672 5.584 5.354 8.609c16.507 4.654 43.496-10.474 45.729-14.89",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.374 103.75s4.685-3.255 4.013-5.584c-1.203-4.186-10.537 8.467-10.537 8.467-4.962-.377-46.42 12.914-46.42 12.914L68.438 79.048c-1.31 1.672-4.847 5.735-10.906 7.714-5.409 1.772-10.005.957-12.047.465 8.466 30.248 12.55 44.65 18.962 49.792 5.8 4.655 16.282 1.861 16.282 1.861s-.672 5.584 5.354 8.609c16.507 4.654 43.304-12.388 46.486-16.054",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.919 118.613s-31.9 18.18-50.193 20.278l50.193-20.278z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.919 118.613s-31.9 18.18-50.193 20.278",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.014 69.436l13.299 37.519a1.57 1.57 0 01-.314 1.576c-2.714 2.975-14.081 14.24-29.016 12.322-.594-.073-1.085-.522-1.237-1.133l-9.281-37.259",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.014 69.436l13.299 37.519a1.57 1.57 0 01-.314 1.576c-2.714 2.975-14.081 14.24-29.016 12.322-.594-.073-1.085-.522-1.237-1.133l-5.19-20.847",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.863 47.74s-4.571 9.243-.558 15.527c1.41 2.206 6.306 8.252 15.839 5.819 5.427-1.388 12.859-7.399 20.746-13.73",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.863 47.74s-4.571 9.243-.558 15.527c1.41 2.206 6.306 8.252 15.839 5.819 5.427-1.388 12.859-7.399 20.746-13.73",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.424 28.134c-3.965 12.237 3.124 28.388 4.53 27.227 4.623-4.128 9.079-10.593 9.079-16.992 0-6.4-4.013-14.194-10.038-17.453-10.438-5.643-18.616-1.303-24.538 5.35-.66.742-1.47 1.341-2.185 2.052 16.614 7.088 23.156-.192 23.156-.192l-.004.008z",
    fill: "#333",
    stroke: "#333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.802 30.724s.414-3.447-2.218-5.096c-2.636-1.649-7.111.757-8.115 5.842-1.005 5.089 3.418 9.074 3.418 9.074",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.802 30.724s.414-3.447-2.218-5.096c-2.636-1.649-7.111.757-8.115 5.842-1.005 5.089 3.418 9.074 3.418 9.074M93.429 32.55s.484-4.493-2.636-4.401M89.656 36.751s-1.123-5.857 2.769-8.121M103.144 36.163s6.133-2.444 9.37 3.025c2.914 4.927-2.141 9.328-3.906 11.984-1.262 1.898-1.731 3.701-1.901 4.785-.1.619-.69 1.01-1.27.838-.727-.212-1.647-.65-2.293-1.576M101.207 42.355s.668 5.315 5.619 5.63M120.031 53.243s1.739-5.1-2.946-8.825M111.048 52.26s-.258 3.597 3.814 3.885",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.266 160.753c1.728 16.288 4.216 29.667 4.744 30.794l23.289-2.633 17.741-10.135.38-27.904s-6.539 5.734-19.062 4.904a2.04 2.04 0 01-.273-.019s-13.384 10.746-26.82 4.997v-.004z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.031 153.17s-11.596 18.96-24.98 18.933c-12.18-1.223-14.166-16.347-14.166-16.347",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.876 59.596s-.953-2.905-3.718-4.174",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "depressiya_svg__clip0_632_7271"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h167v154H0z"
  })))));
}
export default __webpack_public_path__ + "static/depressiya.c878ae1b.svg";
export { SvgDepressiya as ReactComponent };